import React, { useState } from 'react';
import { Container } from 'reactstrap';
import './Hssr.module.scss';
import { UnauthenticatedHeader } from './UnauthenticatedHeader';
import { UnauthenticatedHssrForm } from './UnauthenticatedHssrForm';
import withRouter from '../../hoc/withRouter';
import { decodeBase64Json } from '../Common/accessibilityHelpers';
import { ErrorRequestModal } from '../Common/ErrorRequestModal';
import styles from './Hssr.module.scss';
import { ThemeProvider } from '@mui/material';
import { defaultFormStatus, FormStatus, HssrKey, HssrParams, hssrTheme } from './HssrPage.metadata';
import { useParams } from 'react-router-dom';
import { lang } from './language';
import { useLanguage } from './useLanguage';
import Footer from '../Common/Footer';
import { english } from './english';
import { spanish } from './spanish';

const HssrPage = () => {
    const [formStatus, setFormStatus] = useState<FormStatus>(defaultFormStatus);
    const { hssrKey } = useParams<HssrKey>();
    const memberInfo = decodeBase64Json<HssrParams>(hssrKey);
    const language = useLanguage(memberInfo?.language || '', {
        english,
        spanish,
    });

    const onFormSubmitted = () => {
        setFormStatus({ completed: true, completedOn: new Date() });
    };

    const completedDate = (
        <>
            &nbsp;{language.completed} <span>{formStatus.completedOn?.toDateString()}</span>
        </>
    );

    const toTitleCase = (value: string | null | undefined) =>
        value
            ?.toLowerCase()
            .split(' ')
            .map((word) => (word.length > 1 ? word.charAt(0).toUpperCase() + word.slice(1) : word.toUpperCase()))
            .join(' ');

    const content = (data: HssrParams) => (
        <div className='container'>
            <div className={styles['header']}>
                <h1>{language.title}</h1>
                <h2 className='mb-5'>({language.measurementYear})</h2>
                <div className='row'>
                    <p className='col-sm-12'>{language.alignmentMessageTitle}:</p>
                    <span className='col-sm-12'>
                        {lang(language.alignmentMessage1, { name: toTitleCase(data.memberName) })}
                    </span>
                    <span className='mt-3 col-sm-12' style={{ textDecoration: 'underline' }} dangerouslySetInnerHTML={{__html: language.alignmentMessage2}}>
                    </span>
                    <span className='mt-3 col-sm-12'>{language.alignmentMessage3}</span>
                    <p className={`col-sm-12 mt-3 ${styles.pre}`}>{language.alignmentMessage4}</p>
                </div>
            </div>
            <UnauthenticatedHssrForm language={language} memberData={data} onFormSubmitted={onFormSubmitted} />
            <br />
        </div>
    );

    return (
        <ThemeProvider theme={hssrTheme}>
            <div>
                <UnauthenticatedHeader />
                <Container id='main-container' role='main' aria-label='main content area'>
                    {memberInfo && content(memberInfo)}
                </Container>
                <ErrorRequestModal showErrorModal={!memberInfo} text={language.tokenError} />
                {memberInfo && <Footer />}
            </div>
        </ThemeProvider>
    );
};
export default withRouter(HssrPage);
